/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_Point_0_TextInputs */

const en_visa_eb3_point_0_text = /** @type {(inputs: Visa_Eb3_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We examine the actual position, the employer's needs, and the applicant's credentials to identify the most defensible filing strategy.`)
};

const pt_visa_eb3_point_0_text = /** @type {(inputs: Visa_Eb3_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examinamos o cargo real, as necessidades do empregador e as credenciais do candidato para identificar a estratégia de apresentação mais defensável.`)
};

const es_visa_eb3_point_0_text = /** @type {(inputs: Visa_Eb3_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examinamos el puesto real, las necesidades del empleador y las credenciales del candidato para identificar la estrategia de presentación más defendible.`)
};

/**
* | output |
* | --- |
* | "We examine the actual position, the employer's needs, and the applicant's credentials to identify the most defensible filing strategy." |
*
* @param {Visa_Eb3_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_point_0_text = /** @type {((inputs?: Visa_Eb3_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_point_0_text(inputs)
	if (locale === "es") return es_visa_eb3_point_0_text(inputs)
	return en_visa_eb3_point_0_text(inputs)
});